import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    background: "transparent",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  alert: {
    margin: theme.spacing(3, 0),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  poNumberInput: {
    maxWidth: 226,
    marginBottom: 0,
  },
  productsContainer: {
    display: "flex",
    flexDirection: "column",
  },
  supplierCompanyNameTitle: {
    fontSize: "21px",
  },
  totalSupplierPrice: {
    textAlign: "right",
    fontWeight: 500,
    fontSize: theme.spacing(2),
    marginTop: theme.spacing(3),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  feeItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
  },
  feesContainer: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.separator.main}`,
  },
}));
